import { GridWrapper } from "../wrapper";
import { styled } from "@mui/material/styles";

export const GridGeneric = styled(GridWrapper)(() => ({
    paddingLeft: '30px'
}));